import './index.css';
import { topbar } from "../components/topbar";
import davolash from './files/davolash_tavsifnoma.pdf';
import xalq from './files/xalq_tavsifnoma.pdf';
import imgbook from '../../images/book.png';

export default function Malaka(){
    const books = [
        {'text': 'Davolash ishi fakulteti malaka tavsifnomasi', 'book': davolash},
        {'text': 'Xalq tabobati fakulteti malaka tavsifnomasi', 'book': xalq},
    ];

    const book = books.map((data) => 
        <a href={data.book}>
            <nav>
                <img src={imgbook} alt="file.png"/>
                <p>{data.text}</p>
            </nav>
        </a>
    );

    return(
        <div className="malaka">
            {topbar('Malaka tavsifnomasi', 'malaka tavsifnomasi')}
            <div className="content">
                {book}
            </div>
        </div>
    );
}